import { render, staticRenderFns } from "./occurrenceTypeCrudData.vue?vue&type=template&id=599d5896&scoped=true"
import script from "./occurrenceTypeCrudData.vue?vue&type=script&lang=js"
export * from "./occurrenceTypeCrudData.vue?vue&type=script&lang=js"
import style0 from "./occurrenceTypeCrudData.vue?vue&type=style&index=0&id=599d5896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d5896",
  null
  
)

export default component.exports